import React, { useEffect, useRef, useState } from 'react'
import { BaseConfig } from '../BaseConfig';
import "./media-controls-ui.css"
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { TextHtmlTagType } from '../../misc/tools';

class MixedMediaUIImgCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'back-10',
				src: process.env.PUBLIC_URL + '/assets/images/vid-controller/replay-last-10.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'forward-10',
				src: process.env.PUBLIC_URL + '/assets/images/vid-controller/skip-next-10.svg'
			}
		];
	}
}

export const mixedMediaUIImgCaching = new MixedMediaUIImgCaching();

let id = '';

const MediaControlsUI = (props: MediaControlsUIConfig) => {

	const [isVideoLoaded, setIsVideoLoaded] = useState(false);
	const [isPlaying, setIsPlaying] = useState(false);
	const [videoRef, setVideoRef] = useState(null);
	const [progress, setProgress] = useState(0);
	const [currentTime, setCurrentTime] = useState('00:00');
	const [finalTime, setFinalTime] = useState('00:00');
	const [start, setStart] = useState(undefined);
	const [end, setEnd] = useState(undefined);

	const calcTime = (ref: HTMLVideoElement, start: number, end: number) => {
		const finalTime = end - start;
		const currentTime = ref.currentTime - start;
		const progress = (currentTime/finalTime) * 100;
		const nowTimeMin = Math.floor(currentTime / 60);
		const nowTimeSec = Math.floor(currentTime - nowTimeMin * 60);
		const finalTimeMin = Math.floor(finalTime / 60);
		const finalTimeSec = Math.floor(finalTime - finalTimeMin * 60);

		setCurrentTime(('0' + nowTimeMin).slice(-2) + ':' + ('0' + nowTimeSec).slice(-2));
		setFinalTime(('0' + finalTimeMin).slice(-2) + ':' + ('0' + finalTimeSec).slice(-2));

		return progress;
	}

	const updateRef = (videoElementParentId: string) => {
		id = videoElementParentId;
		const ref = document.getElementById(videoElementParentId).getElementsByTagName('video')[0];
		if(!videoRef) {
			setVideoRef(ref);
		}

		return ref;
	}

	(window as any)['media-controls-on-video-loaded' + props.mediaId] = () => {
		setIsVideoLoaded(true);
		togglePlay();
	}

	(window as any)['media-controls-handle-progress' + props.mediaId] = (videoElementParentId: string, s: number, e: number) => {
		const ref = updateRef(videoElementParentId);
		const progress = calcTime(ref, typeof start === 'undefined' ? s : start, typeof end === 'undefined' ? e : end);
		if(typeof start === 'undefined') {
			setStart(s);
		}

		if(typeof end === undefined) {
			setEnd(e);
		}

		setProgress(progress);
		if (progress >= 100) {
			(window as any)['mentor-ui-update-video-done-playing' + props.mediaId]();
		}
	}
	const togglePlay = () => {
		const playing = !isPlaying;
		(window as any)['mentor-ui-update-video-playing' + props.mediaId](playing);

		(window as any)['mentor-ui-update-video-done-playing' + props.mediaId] = () => {
			(window as any)['mentor-ui-update-video-done-playing2' + props.mediaId]();
			setIsPlaying(false);
			setTimeout(() => {
				setProgress(0);
				setCurrentTime('00:00')
			}, 100);
		};

		setIsPlaying(playing);
	}
	const skipBack = () => {
		// const ref = updateRef(id);

		// if(ref) {
			if((window as any)['mentor-ui-update-video-skip-back' + props.mediaId]) {
				(window as any)['mentor-ui-update-video-skip-back' + props.mediaId]();
			}
			// ref.currentTime = ref.currentTime-10;
		// }
	}
	const skipForward = () => {
		if((window as any)['mentor-ui-update-video-skip-forward' + props.mediaId]) {
			(window as any)['mentor-ui-update-video-skip-forward' + props.mediaId]();
		}
		// const ref = updateRef(id);

		// if(ref) {
		// 	const finalTime = ref.duration;
		// 	const timeDiff = finalTime - ref.currentTime
		// 	if (timeDiff <= 10) {
		// 		ref.currentTime = finalTime - 1;
		// 	} else ref.currentTime = ref.currentTime + 10;
		// }
	} 

	const dynamicStyle = (requiresPlay?: boolean) => {
		if(requiresPlay) {
			return {
				pointerEvents: isVideoLoaded && isPlaying ? 'all' : 'none',
				opacity: isVideoLoaded && isPlaying ? '1' : '0.5',
			} as any;
		}
		return {
			pointerEvents: isVideoLoaded ? 'all' : 'none',
			opacity: isVideoLoaded ? '1' : '0.5'
		} as any;
	}
	const tIndex = () => {
		if(isVideoLoaded && isPlaying) {
			return 0;
		} else return -1;
	}
	const playIndex = () => {
		if(isVideoLoaded) {
			return 0;
		} else return -1;
	}

	return (
		<div className='media-controls-ui'>
			<div className='media-controls-ui-content-container main-content-inner'>
				<div className='media-controls-ui-controls-container'>
					<button tabIndex={playIndex()} style={{
						...dynamicStyle()}} onClick={() => togglePlay()} className='default-text media-controls-ui-mixed-media-bttn'>{isPlaying ? "Pause" : "Play"}</button>
					<progress className='media-controls-ui-media-controls-ui-mixed-media-bar' value={progress} max="100"></progress>
					<p className='default-text media-controls-ui-mixed-media-time black-text center-element-vertical'>{currentTime} / {finalTime}</p>
					<button style={{
						...dynamicStyle(true)}} tabIndex={tIndex()} onClick={() => skipBack()} className='default-text media-controls-ui-mixed-media-bttnBack'>{<img src={mixedMediaUIImgCaching.getItemByKey('back-10').src}></img>}</button>
					<button style={{
						...dynamicStyle(true)}} tabIndex={tIndex()} onClick={() => skipForward()} className='default-text media-controls-ui-mixed-media-bttnForward'>{<img src={mixedMediaUIImgCaching.getItemByKey('forward-10').src}></img>}</button>
				</div>
			</div>
		</div>
	);

};

export interface MediaControlsUIConfig extends BaseConfig {
	mediaId: string;
}

export default MediaControlsUI;